const initialState = { promoCode: null, codeApplied: false, triggerGetBasket: 0 };

const promoCode = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PROMO_CODE':
            return {
                ...state,
                promoCode: action.payload,
            };
        case 'SET_PROMO':
            return {
                ...state,
                promo: action.payload
            };
        case 'SET_PROMO_CODE_APPLIED':
            return {
                ...state,
                codeApplied: action.payload
            };
        case 'PROMO_CODE_TRIGGER_GET_BASKET':
            return {
                ...state,
                triggerGetBasket: state.triggerGetBasket + 1
            };
        default:
            return state;
    }
};

export default promoCode;